import axios from 'axios';
const Token = JSON.parse(localStorage.getItem("token"))

export const getEmployeeAPI = async () =>
    await axios.get(process.env.REACT_APP_API_URL + '/employee/', {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })